import { createContext, useContext } from 'react'
import { OpsApi } from './OpsApi'

/**
 * Modul nevolá síť napřímo — implementaci OpsApi dostává zvenku (stejný vzor jako
 * CurrentUser): dev harness dodává mock, reálná aplikace klienta nad /api/funds/*.
 */
const OpsApiContext = createContext<OpsApi | null>(null)

export const OpsApiProvider = OpsApiContext.Provider

export function useOpsApi(): OpsApi {
  const api = useContext(OpsApiContext)
  if (!api) {
    throw new Error('useOpsApi musí být použit uvnitř OpsApiProvider')
  }
  return api
}
